import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Paragraph from '../Paragraph/Paragraph';
import { Heading } from '../Heading';
import themeColors from '../../assets/styles/themeColors';

const IconListItemContainer = styled.li`
  display: grid;
  grid-template-columns: 4rem 1fr;
  grid-gap: 1.5rem;
`;

const ContentWrap = styled.div`
  display: flex;
  flex-direction: column;
`;

const IconListItem = ({ title, description, Icon }) => (
  <IconListItemContainer>
    {Icon && <Icon />}
    <ContentWrap>
      {title && <Heading mb={12}>{title}</Heading>}
      {description && (
        <Paragraph color={themeColors.colorTextXLLight}>
          {description}
        </Paragraph>
      )}
    </ContentWrap>
  </IconListItemContainer>
);

IconListItem.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  Icon: PropTypes.func,
};

export default IconListItem;
